import {
  Button,
  Checkbox, Input, Label, Select,
} from '@ipc/ipc-components';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getData,
  getDataInactive, getInboundDataLocationsList,
  getMrdTypes, getPersistFormData,
  getPostalOperators,
} from '../../redux/selectors/DeviceInformationSelectors';
import { getAllImpcList } from '../../../../../common/impc/redux/selectors/ImpcSelectors';
import { getAllIataCodes } from '../../../flight-information/redux/selectors/FlightInformationSelectors';
import {
  addMrdRequestActionCreator, getInboundDataLocationsRequestActionCreator,
  getMrdFormFieldsRequestActionCreator, setAddMrdSuccessStatusActionCreator,
} from '../../redux/actions/DeviceInformationActions';
import { AddMrdFormStyle } from '../component/AddMrdForm.styles';
import { getAllIataCodesRequestActionCreator } from '../../../flight-information/redux/actions/FlightInformationActions';
import { formatMessage } from '../../../../../../locales/locales';

function AddMrdForm(props) {
  const {
    getFormFields,
    mrdTypeList,
    impcList,
    iataCodeList,
    postalOperatorList,
    activeMrdList,
    inactiveMrdList,
    inboundDataLocationList,
    addMrdRequest,
    persistFormData,
    setAddMrdStatus,
    closeWizard,
    setSelectedImpc,
    setAddedMrdName,
    getAllIata,
    getInboundDataLocationList,
  } = props;

  const [mrdName, setMrdName] = useState(persistFormData.mrdName || '');
  const [deviceType, setDeviceType] = useState(persistFormData.deviceType || { value: null, label: 'Select...' });
  const [physicalMrd, setPhysicalMrd] = useState(persistFormData.physicalMrd || false);
  const [impc, setImpc] = useState(persistFormData.impc || null);

  const [airport, setAirport] = useState(persistFormData.airport || null);
  const [operator, setOperator] = useState(persistFormData.operator || null);
  const [macAddress, setMacAddress] = useState(persistFormData.macAddress || '');

  const [dataLocation, setDataLocations] = useState('');

  const [isMrdNameUnique, setIsMrdNameUnique] = useState(true);
  const [macAddressErrorMessage, setMacAddressErrorMessage] = useState('');

  const [kioskModel, setKioskModel] = useState(persistFormData.kioskModel || '');
  const [printerModel, setPrinterModel] = useState(persistFormData.printerModel || '');
  const [scannerModel, setScannerModel] = useState(persistFormData.scannerModel || '');

  const [teamViewerId, setTeamViewerId] = useState(persistFormData.teamViewerId || '');

  const [printFlightBarcode, setPrintFlightBarcode] = useState(persistFormData.printFlightBarcode || false);
  const [printStartStopBarcode, setPrintStartStopBarcode] = useState(persistFormData.printStartStopBarcode || false);
  const [ticketButton, setTicketButton] = useState(persistFormData.ticketButton || false);
  const [flightInfoButton, setFlightInfoButton] = useState(persistFormData.flightInfoButton || false);
  const [manualEntryOption, setManualEntryOption] = useState(persistFormData.manualEntryOption || false);

  const handleMrdName = (e) => {
    const duplicateMrdNameControl = (mrdObject) => {
      if (!mrdObject.mrdName) return false;
      return mrdObject.mrdName.toUpperCase() === e.target.value.trim().toUpperCase();
    };
    const isDuplicate = activeMrdList.some(duplicateMrdNameControl) || inactiveMrdList.some(duplicateMrdNameControl);
    setIsMrdNameUnique(!isDuplicate);
    setMrdName(e.target.value);
  };

  const handleDeviceType = (selectedDeviceType) => {
    setDeviceType(selectedDeviceType);
    if (selectedDeviceType.value !== 'D') {
      setPrintFlightBarcode(false);
      setPrintStartStopBarcode(false);
      setTicketButton(false);
      setFlightInfoButton(false);
      setManualEntryOption(false);
    }
  };

  const handlePhysicalMrd = (e) => {
    setPhysicalMrd(e.target.checked);
  };

  const handleAirport = (selectedAirport) => {
    setAirport(selectedAirport.value);
  };

  const handleOperator = (selectedOperator) => {
    setOperator(selectedOperator.value);
  };

  const handleDataLocation = (selectedDataLocation) => {
    setDataLocations(selectedDataLocation.value);
  };

  const handleImpc = (selectedImpc) => {
    setImpc(selectedImpc.value);
  };

  const handleMacAddress = (e) => {
    setMacAddress(e.target.value.toUpperCase());
  };

  const handleKioskModel = (e) => {
    setKioskModel(e.target.value);
  };

  const handlePrinterModel = (e) => {
    setPrinterModel(e.target.value);
  };

  const handleScannerModel = (e) => {
    setScannerModel(e.target.value);
  };

  const handleTeamViewerId = (e) => {
    setTeamViewerId(e.target.value);
  };

  const handlePrintFlightBarcode = (e) => {
    setPrintFlightBarcode(e.target.checked);
  };

  const handlePrintStartStopBarcode = (e) => {
    setPrintStartStopBarcode(e.target.checked);
  };

  const handleTicketButton = (e) => {
    setTicketButton(e.target.checked);
  };

  const handleFlightInfoButton = (e) => {
    setFlightInfoButton(e.target.checked);
  };

  const handleManualEntryOption = (e) => {
    setManualEntryOption(e.target.checked);
  };

  const keyPressHandle = (e) => {
    const re = /[a-fA-F\d-]+/g;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  };

  async function handleOnNext() {
    await addMrdRequest({
      mrdName: mrdName.trim(),
      deviceType: deviceType.value,
      mrdStatus: 'N',
      airport,
      impc,
      operator,
      physicalMrd,
      dataLocationId: (dataLocation === '' || dataLocation === -1) ? null : dataLocation,
      macAddress: macAddress === '' ? null : macAddress,
      kioskModel: kioskModel === '' ? null : kioskModel,
      printerModel: printerModel === '' ? null : printerModel,
      scannerModel: scannerModel === '' ? null : scannerModel,
      teamViewerId: teamViewerId === '' ? null : teamViewerId,
      printFlightBarcode: deviceType.value !== 'D' ? null : printFlightBarcode,
      printStartStopBarcode: deviceType.value !== 'D' ? null : printStartStopBarcode,
      ticketButton: deviceType.value !== 'D' ? null : ticketButton,
      flightInfoButton: deviceType.value !== 'D' ? null : flightInfoButton,
      manualEntryOption: deviceType.value !== 'D' ? null : manualEntryOption,
    },
    {
      mrdName: mrdName.trim(),
      deviceType,
      airport,
      impc,
      operator,
      physicalMrd,
      dataLocationId: (dataLocation === '' || dataLocation === -1) ? null : dataLocation,
      macAddress: macAddress === '' ? null : macAddress,
      kioskModel: kioskModel === '' ? null : kioskModel,
      printerModel: printerModel === '' ? null : printerModel,
      scannerModel: scannerModel === '' ? null : scannerModel,
      teamViewerId: teamViewerId === '' ? null : teamViewerId,
      printFlightBarcode,
      printStartStopBarcode,
      ticketButton,
      flightInfoButton,
      manualEntryOption,
    });
    setAddMrdStatus(false);
    setSelectedImpc(impc);
    setAddedMrdName(mrdName.trim());
  }

  const isFormValid = () => !!mrdName.trim() && isMrdNameUnique && !!deviceType?.value && !!impc && !!airport && !!operator && macAddressErrorMessage === '';

  const getMacAddressMessage = (value) => {
    const invalidMessage = formatMessage('en', 'device.information.mac.address.validation.message');
    const notUniqueMessage = formatMessage('en', 'device.information.mac.address.unique.validation.message');
    const macAddressRegex = /^([0-9A-F]{2}[-]){5}([0-9A-F]{2})$/;

    const duplicateMacControl = (mrdObject) => {
      if (!mrdObject.macAddress) return false;
      return mrdObject.macAddress.toUpperCase() === value.toUpperCase();
    };

    if (value !== '' && !macAddressRegex.test(value)) return invalidMessage;

    const isDuplicate = activeMrdList.some(duplicateMacControl) || inactiveMrdList.some(duplicateMacControl);
    return isDuplicate ? notUniqueMessage : '';
  };

  useEffect(() => {
    setMacAddressErrorMessage(getMacAddressMessage(macAddress));
  }, [macAddress]);

  useEffect(() => {
    getFormFields();
    getAllIata({ params: { all: 'Y', iataSort: true } });
    getInboundDataLocationList();
  }, []);

  return (
    <AddMrdFormStyle>
      <div className="add-mrd-container-buttons">
        <Button id="cancel" className="cancel" onClick={closeWizard}>Cancel</Button>
        <Button
          id="next"
          onClick={handleOnNext}
          className={`primary-button-${!isFormValid()} right-alignment`}
          disabled={!isFormValid()}
        >
          Next
        </Button>
        <div className="save-label right-alignment">
          <Label>Follow the wizard to add the new MRD: </Label>
        </div>
      </div>
      <div className="add-mrd-container-body">
        <div className="mrd-add-form-row">
          <div className="mrd-add-form-side-left">
            <div className="form-input-fields left-field-label">
              <Label>MRD name*</Label>
            </div>
            <div className="disabled-input form-input-fields">
              <Input
                type="text"
                value={mrdName}
                maxLength={8}
                onChange={handleMrdName}
              />
            </div>
            <div className="form-input-fields unique-error">
              {mrdName && !isMrdNameUnique && (
                <span className="unique-error-text">
                  {formatMessage('en', 'device.information.mrd.name.unique.validation.message')}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="mrd-add-form-row">
          <div className="mrd-add-form-side-left">
            <div className="form-input-fields left-field-label">
              <Label>Device type*</Label>
            </div>
            <div className="form-input-fields">
              <Select
                value={deviceType.value}
                placeholder={deviceType.label || 'Select...'}
                options={mrdTypeList.map((type) => ({
                  value: type.code,
                  label: type.description,
                }))}
                onChange={handleDeviceType}
              />
            </div>
          </div>
          <div className="mrd-add-form-side-right">
            <div className="form-input-fields left-field-label">
              <Label>MRD status*</Label>
            </div>
            <div className="form-input-fields">
              <Select
                placeholder="New"
                isDisabled
              />
            </div>
          </div>
        </div>
        <div className="mrd-add-form-row">
          <div className="mrd-add-form-side-left">
            <div className="form-input-fields left-field-label">
              <Label>IMPC*</Label>
            </div>
            <div className="form-input-fields">
              <Select
                value={impc}
                placeholder={impc || 'Select...'}
                options={impcList.map((element) => ({
                  value: element.impc,
                  label: element.impc,
                }))}
                onChange={handleImpc}
              />
            </div>
          </div>
          <div className="mrd-add-form-side-right">
            <div className="form-input-fields left-field-label">
              <Label>Airport (IATA)*</Label>
            </div>
            <div className="form-input-fields">
              <Select
                value={airport}
                placeholder={airport || 'Select...'}
                options={iataCodeList.map((iata) => ({
                  value: iata.iata,
                  label: iata.iata,
                }))}
                onChange={handleAirport}
              />
            </div>
          </div>
        </div>
        <div className="mrd-add-form-row">
          <div className="mrd-add-form-side-left">
            <div className="form-input-fields left-field-label">
              <Label>Operator*</Label>
            </div>
            <div className="form-input-fields">
              <Select
                value={operator}
                placeholder={operator || 'Select...'}
                options={postalOperatorList.map((element) => ({
                  value: element,
                  label: element,
                }))}
                onChange={handleOperator}
                maxMenuHeight={250}
              />
            </div>
          </div>
          <div className="mrd-add-form-side-right">
            <div className="form-input-fields left-field-label">
              <Label>Data Location</Label>
            </div>
            <div className="form-input-fields">
              <Select
                value={dataLocation.value}
                placeholder={dataLocation.label || 'Select...'}
                onChange={handleDataLocation}
                options={[{ value: -1, label: 'Select a location' }].concat(inboundDataLocationList.map((element) => ({
                  value: element.id,
                  label: element.dataLocation,
                })))}
              />
            </div>
          </div>
        </div>
        <div className="mrd-add-form-row">
          <div className="mrd-add-form-side-left">
            <div className="form-input-fields left-field-label">
              <Label>MAC Address</Label>
            </div>
            <div className="form-input-fields">
              <Input
                id="macAddress"
                type="text"
                value={macAddress}
                maxLength={17}
                onChange={handleMacAddress}
                onKeyPress={(e) => keyPressHandle(e)}
                style={{ textTransform: 'uppercase' }}
              />
            </div>
            <div className="form-input-fields unique-error">
              {macAddress && (macAddressErrorMessage !== '') && (
                <span className="unique-error-text">
                  {macAddressErrorMessage}
                </span>
              )}
            </div>
          </div>
          <div className="mrd-add-form-side-right">
            <div className="form-input-fields">
              <Label>Physical MRD</Label>
            </div>
            <div className="form-input-fields">
              <Checkbox
                checked={physicalMrd}
                onChange={handlePhysicalMrd}
              />
            </div>
          </div>
        </div>
        <div className="mrd-add-form-row">
          <div className="mrd-add-form-side-left">
            <div className="form-input-fields left-field-label">
              <Label>Kiosk model</Label>
            </div>
            <div className="form-input-fields long-input">
              <Input
                type="text"
                value={kioskModel}
                maxLength={35}
                onChange={handleKioskModel}
              />
            </div>
          </div>
          {deviceType && deviceType.label === 'POD' && (
            <div className="mrd-add-form-side-right">
              <div className="form-input-fields">
                <Label>Print flight barcode</Label>
              </div>
              <div className="form-input-fields">
                <Checkbox
                  checked={printFlightBarcode}
                  onChange={handlePrintFlightBarcode}
                />
              </div>
            </div>
          )}
        </div>
        <div className="mrd-add-form-row">
          <div className="mrd-add-form-side-left">
            <div className="form-input-fields left-field-label">
              <Label>Printer model</Label>
            </div>
            <div className="form-input-fields long-input">
              <Input
                type="text"
                value={printerModel}
                maxLength={35}
                onChange={handlePrinterModel}
              />
            </div>
          </div>
          {deviceType && deviceType.label === 'POD' && (
            <div className="mrd-add-form-side-right">
              <div className="form-input-fields">
                <Label>Print start stop barcode</Label>
              </div>
              <div className="form-input-fields">
                <Checkbox
                  checked={printStartStopBarcode}
                  onChange={handlePrintStartStopBarcode}
                />
              </div>
            </div>
          )}
        </div>
        <div className="mrd-add-form-row">
          <div className="mrd-add-form-side-left">
            <div className="form-input-fields left-field-label">
              <Label>Scanner model</Label>
            </div>
            <div className="form-input-fields long-input">
              <Input
                type="text"
                value={scannerModel}
                maxLength={35}
                onChange={handleScannerModel}
              />
            </div>
          </div>
          {deviceType && deviceType.label === 'POD' && (
            <div className="mrd-add-form-side-right">
              <div className="form-input-fields">
                <Label>Ticket button</Label>
              </div>
              <div className="form-input-fields">
                <Checkbox
                  checked={ticketButton}
                  onChange={handleTicketButton}
                />
              </div>
            </div>
          )}
        </div>
        <div className="mrd-add-form-row">
          <div className="mrd-add-form-side-left">
            <div className="form-input-fields left-field-label">
              <Label>Team Viewer ID</Label>
            </div>
            <div className="form-input-fields long-input">
              <Input
                type="text"
                value={teamViewerId}
                maxLength={20}
                onChange={handleTeamViewerId}
              />
            </div>
          </div>
          {deviceType && deviceType.label === 'POD' && (
            <div className="mrd-add-form-side-right">
              <div className="form-input-fields">
                <Label>Flight info button</Label>
              </div>
              <div className="form-input-fields">
                <Checkbox
                  checked={flightInfoButton}
                  onChange={handleFlightInfoButton}
                />
              </div>
            </div>
          )}
        </div>
        {deviceType && deviceType.label === 'POD' && (
          <>
            <div className="mrd-add-form-row">
              <div className="mrd-add-form-side-left">
                <div className="form-input-fields left-field-label" />
              </div>
              <div className="mrd-add-form-side-right">
                <div className="form-input-fields">
                  <Label>Manual entry option</Label>
                </div>
                <div className="form-input-fields">
                  <Checkbox
                    checked={manualEntryOption}
                    onChange={handleManualEntryOption}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </AddMrdFormStyle>
  );
}

function mapStateToProps(state) {
  return {
    mrdTypeList: getMrdTypes(state),
    postalOperatorList: getPostalOperators(state),
    impcList: getAllImpcList(state),
    iataCodeList: getAllIataCodes(state),
    activeMrdList: getData(state),
    inactiveMrdList: getDataInactive(state),
    persistFormData: getPersistFormData(state),
    inboundDataLocationList: getInboundDataLocationsList(state),
  };
}

AddMrdForm.propTypes = {
  getFormFields: PropTypes.func,
  mrdTypeList: PropTypes.arrayOf(PropTypes.object),
  postalOperatorList: PropTypes.arrayOf(PropTypes.string),
  impcList: PropTypes.arrayOf(PropTypes.object),
  iataCodeList: PropTypes.arrayOf(PropTypes.object),
  activeMrdList: PropTypes.arrayOf(PropTypes.object),
  inactiveMrdList: PropTypes.arrayOf(PropTypes.object),
  addMrdRequest: PropTypes.func,
  persistFormData: PropTypes.objectOf(PropTypes.shape),
  setAddMrdStatus: PropTypes.func,
  closeWizard: PropTypes.func,
  setSelectedImpc: PropTypes.func,
  setAddedMrdName: PropTypes.func,
  getAllIata: PropTypes.func,
  inboundDataLocationList: PropTypes.arrayOf(PropTypes.object),
  getInboundDataLocationList: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  addMrdRequest: addMrdRequestActionCreator,
  getFormFields: getMrdFormFieldsRequestActionCreator,
  setAddMrdStatus: setAddMrdSuccessStatusActionCreator,
  getAllIata: getAllIataCodesRequestActionCreator,
  getInboundDataLocationList: getInboundDataLocationsRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddMrdForm);
